import axios from 'axios';

const REQUEST_COUNTRY_PATH = '/api/v1/request-country';

export interface UserLocation {
  country: string | undefined;
  ip: string | undefined;
}

export async function getUserLocation(): Promise<UserLocation> {
  try {
    const response = await axios.get(REQUEST_COUNTRY_PATH);
    return response.data;
  } catch (error) {
    return {
      country: undefined,
      ip: undefined,
    };
  }
}
